import { observer } from 'mobx-react-lite'
import { Button } from 'shared/ui'
import { type GetDemoModalStore } from 'entities/Subscription/ui/GetDemoModal/store/getDemoModalStore'

type IGetDemoModalActionsProps = {
  store: GetDemoModalStore
}

export const GetDemoModalActions = observer(({ store }: IGetDemoModalActionsProps) => {
  return (
    <>
      <Button
        typeBtn={'contained'}
        contained={'secondary'}
        size={'medium'}
        text={'Cancel'}
        onClick={store.close}
        disabled={store.loading}
      />
      <Button
        typeBtn={'contained'}
        size={'medium'}
        text={'Request demo'}
        onClick={store.submit}
        loading={store.loading}
        disabled={store.loading}
      />
    </>
  )
})
